import React from "react";

import { Title } from "./styles";

interface TitleProps {
  isActive?: boolean;
  children?: React.ReactNode;
}

export function TitleComponent({ children, isActive = false }: TitleProps) {
  return <Title isActive={isActive}>{children}</Title>;
}
